export const getInitials = (name) => {
    const initials = name.split(' ');
    return `${initials[0][0]}${initials[1][0]}`;
};
